import React, { useEffect } from "react";
import MiniHero from "./../MiniHero";

function ServicePolicy({ homeRef, handleScroll }) {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <MiniHero
        homeRef={homeRef}
        onScroll={handleScroll}
        title="TML Policy"
        className="fs-48 text-dark mb-5"
      />
      <div className="container py-5">
        <div className="max-width-720 mx-auto">
          <p>
            Tanaad Money Ltd has been granted Authorisation by the Financial
            Conduct Authority (FCA) to carry on payment services activities as a
            PSD agent from 23 May 2019, under the Payment Services Regulations
            2017(Authorisation number: 842687).
          </p>
          <p>
            Tanaad Money Ltd is a Money Services Business regulated by the HMRC
            and registered for Money laundering regulations (MLR registration
            number: XWML00000139421). Our compliance officer, nominated officer
            according to the FCA/HMRC rules, works with management and staff to
            identify and manage regulatory risk. He makes sure Tanaad Money ltd
            complies with the Money Laundering Regulations.
          </p>
          <h2 className="fs-2">
            Tanaad, Money laundering controls are implemented through the
            following steps:
          </h2>
          <ul>
            <li className="mb-2">Training staff</li>
            <li className="mb-2">
              Producing and maintaining our TML handbook of Policies and
              Procedures (adapted to each country)
            </li>
            <li className="mb-2">
              Continual updates for staff and Partners through training,
              circulars and newsletters
            </li>
            <li className="mb-2">Inbuilt controls in our software/systems</li>
            <li className="mb-2">Audit and sampling checks of transactions</li>
            <li className="mb-2">
              Reporting to the National Crimes Agency (NCA) when appropriate
            </li>
          </ul>
          <p>
            The software system used by all Tanaad staff is fully compliant with
            the laid down procedures required by the regulators in the UK and
            adapted to the rest of Europe compliance rules. The software has
            in-built Money Laundering filters that are able to identify, monitor
            and track transactions.
          </p>
          <p>
            Our own Tanaad software programme monitors all payments on the basis
            of our Money Laundering Procedures as required by the FCA and HMRC
            and any changes to the requirements will be automatically reflected
            on our Tanaad software.
          </p>
          <p>
            We are working closely with our regulators to make sure we comply
            with their rules.
          </p>
        </div>
      </div>
    </>
  );
}

export default ServicePolicy;
